import React from 'react';
import './RoundButton.css';

const RoundButton = ({ letter }) => {
    return (
        <button className="round-button">
            {letter}
        </button>
    );
};

export default RoundButton;